// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TFST","index":"styles_index__2ILmE"};